import {
  APP_PRIMARY_THEME_COLOR,
  BLACK_TEXT,
  BRIGHT_GREY,
  DIM_GREY,
  ECLIPSE,
  GREY91,
  GREY97,
  WHITE,
} from "../../consts/colors";

export const styles = {
  container: {
    backgroundColor: GREY97,
    padding: "1.5rem",
    display: "flex",
    flexDirection: "column",
  },
  heading: {
    color: ECLIPSE,
    fontWeight: 500,
    fontSize: "24px",
    lineHeight: "32px",
    marginBottom: "16px",
  },
  select: {
    width: "100%",
    backgroundColor: GREY97,
    border: `1px solid ${BRIGHT_GREY}`,
    borderRadius: "4px",
    marginBottom: "20px",
    "& .MuiSelect-select": {
      padding: "12px 16px",
      display: "flex",
      alignItems: "center",
    },
    "& fieldset": {
      border: "none",
    },
    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
      border: `1px solid ${APP_PRIMARY_THEME_COLOR}`,
    },
  },
  placeholder: {
    color: DIM_GREY,
    fontSize: "14px",
  },
  selectedValue: {
    display: "flex",
    alignItems: "center",
    gap: "12px",
  },
  selectedLabel: {
    color: BLACK_TEXT,
    fontWeight: 500,
    fontSize: "14px",
  },
  menuItem: {
    display: "flex",
    alignItems: "center",
    gap: "12px",
    fontSize: "14px",
    color: DIM_GREY,
    "&:hover": {
      background: GREY91,
    },
    "&.Mui-selected": {
      backgroundColor: `${APP_PRIMARY_THEME_COLOR} !important`,
      color: WHITE,
    },
  },
  flag: {
    width: "28px",
    height: "28px",
    borderRadius: "50%",
    objectFit: "cover",
  },
  optionsContainer: {
    display: "flex",
    flexDirection: "column",
    gap: "4px",
    marginBottom: "24px",
  },
  optionLabel: {
    marginLeft: 0,
    marginRight: 0,
    "& .MuiFormControlLabel-label": {
      fontSize: "15px",
      color: ECLIPSE,
    },
  },
  radio: {
    color: BRIGHT_GREY,
    "&.Mui-checked": {
      color: APP_PRIMARY_THEME_COLOR,
    },
  },
  checkbox: {
    color: BRIGHT_GREY,
    "&.Mui-checked": {
      color: APP_PRIMARY_THEME_COLOR,
    },
  },
  applyButton: {
    width: "100%",
    height: "44px",
    backgroundColor: APP_PRIMARY_THEME_COLOR,
    color: WHITE,
    fontWeight: 700,
    fontSize: "16px",
    textTransform: "none",
    borderRadius: "8px",
    "&:hover": {
      backgroundColor: APP_PRIMARY_THEME_COLOR,
    },
  },
  currentDefaultNote: {
    fontSize: "13px",
    fontWeight: 500,
    color: ECLIPSE,
    marginBottom: "16px",
    textAlign: "center",
    padding: "10px 12px",
    backgroundColor: GREY91,
    borderRadius: "6px",
    border: `1px solid ${BRIGHT_GREY}`,
  },
};
